var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.742 17.039h2.883V12.75h-3.41c-4.113.176-4.957 2.496-5.027 4.922v2.145h-2.813V24h2.813v11.25h4.218V24h3.48l.669-4.183h-4.149v-1.301a1.394 1.394 0 011.336-1.477z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjMuMjUiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0yNi43NDIgMTcuMDM4OUgyOS42MjVWMTIuNzVIMjYuMjE0N0MyMi4xMDE3IDEyLjkyNTkgMjEuMjU4IDE1LjI0NiAyMS4xODc1IDE3LjY3MTlWMTkuODE2NUgxOC4zNzVWMjRIMjEuMTg3NVYzNS4yNUgyNS40MDYyVjI0SDI4Ljg4NjZMMjkuNTU0NSAxOS44MTY1SDI1LjQwNjJWMTguNTE1NkMyNS4zOTQ5IDE4LjMzMDUgMjUuNDIwNyAxOC4xNDUgMjUuNDgyIDE3Ljk2OTlDMjUuNTQzNCAxNy43OTQ5IDI1LjYzOTEgMTcuNjMzOCAyNS43NjM1IDE3LjQ5NjNDMjUuODg3OSAxNy4zNTg3IDI2LjAzODYgMTcuMjQ3NCAyNi4yMDY2IDE3LjE2ODlDMjYuMzc0NiAxNy4wOTAzIDI2LjU1NjcgMTcuMDQ2MSAyNi43NDIgMTcuMDM4OVYxNy4wMzg5WiIgIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgIconFacebook as ReactComponent };